module.exports = "/_next/static/images/close-89095885703cc2c1a437226e181bdbef.svg";